export default "__VITE_ASSET__mg6f2_8U__"